import { Component } from '@angular/core';
import {
  IonicPage, NavController, NavParams,
  AlertController, Platform, ModalController
} from 'ionic-angular';
import {  ContenedorEditarPage } from '../contenedor-editar/contenedor-editar'
import { Storage } from '@ionic/storage'
import { CargosProvider } from '../../providers/cargos/cargos'
import { CompaniasProvider } from '../../providers/companias/companias'
import { AuthService } from '../../providers/auth-service'
import { contenedor } from '../../models/contenedor';
@IonicPage()
@Component({
  selector: 'page-contenedor',
  templateUrl: 'contenedor.html',
  providers: [AuthService]
})
export class ContenedorPage {
nombreContenedor:string
codigoContenedor:string
contenedor = []
nombreCompaniaHeader:any=""
nombreCargoHeader:any=""
constructor(public navCtrl: NavController, public navParams: NavParams,
  public alertControllers: AlertController,
  public platforms: Platform,
  public modalControllers: ModalController,
  public servicio: CargosProvider ,
  public servicioCompania:CompaniasProvider,
  public auth: AuthService,
  public storages:Storage
) {
    this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo'])
    .then((val)=>{
    if(val){
    this.nombreCompaniaHeader = val['nombreCompania']
    this.nombreCargoHeader = val['nombreCargo']
    }
    })

}

ionViewDidLoad() {
  this.cargarServicio()
}

cargarServicio() {
  this.storages.get('companiasId').then((val)=>{
    this.servicio.buscarContenedores(val)
    .subscribe((data) => {
      this.contenedor = data
    }, error => {
      console.log(error)
    })
})
}

guardar() {

  let datosContenedor: any = {
    nombreContenedor: this.nombreContenedor,
    codigoContenedor: this.codigoContenedor,
    queHago: "I",
    nombreTabla: "contenedor",
    name: "dataDynamicCrud"
  }
  this.storages.get('companiasId').then((val)=>{
    datosContenedor['companiasId'] = val
    this.servicio.guardarTodo(datosContenedor)
    .subscribe(
      res => {
        
        this.contenedor.push(res[0])
      },
      err => console.log(err)
    )
  })


  this.nombreContenedor = ""
  this.codigoContenedor = ""
}


editar(contenedor: contenedor) {
  let modal = this.modalControllers.create(ContenedorEditarPage, { contenedor })
  modal.present();

  modal.onDidDismiss(data => {
    if (data) {
      
      data.name = "dataDynamicCrud"
      data.contenedorId = data.contenedorId
      data.queHago = "A"
      data.nombreTabla = "contenedor"

      this.servicio.actualizarTodo(data)
      .subscribe(
        res => {
          this.contenedor = []
          this.cargarServicio()
        },
        err => console.log(err)
      )
    }
  })
}

editarRegistros(originalTodo: contenedor, modificadoTodo: contenedor) {
  const index = this.contenedor.indexOf(originalTodo);
  this.contenedor = [
    ...this.contenedor.slice(0, index),
    modificadoTodo,
    ...this.contenedor.slice(index + 1)
  ]
  this.contenedor = []
  this.cargarServicio()
}

eliminar(todo: any) {
  let contenedor = []
  contenedor['queHago'] = "E"
  contenedor['name'] = "dataDynamicCrud"
  contenedor['nombreTabla'] = "contenedor"
  contenedor['contenedorId'] = todo.contenedorId
  this.servicio.eliminarContenedor(contenedor)
  .subscribe(
    res => {
      this.contenedor = []
      this.cargarServicio()
    },
    err => console.log(err)
  )
}
cerrarSession(){
  this.auth.logout()
  this.navCtrl.setRoot('LoginPage');
}  
}



// WEBPACK FOOTER //
// ./src/pages/contenedor/contenedor.ts